export const errorDictionaries = [
  {
    status: 400,
    statusTypeName: 'Bad Request',
    description: 'JWT Token is required',
    event: 'When passing correct client credentials but not passing the token',
  },
  {
    status: 401,
    statusTypeName: 'Unauthorized',
    description: 'Invalid token',
    event: 'When passing correct client credentials but wrong passing the token',
  },
  {
    status: 401,
    statusTypeName: 'Unauthorized',
    description: 'Authentication denied',
    event: 'When not passing client credentials',
  },
  {
    status: 401,
    statusTypeName: 'Unauthorized',
    description: 'Invalid Client',
    event: 'When passing wrong credentials',
  },
  {
    status: 401,
    statusTypeName: 'Unauthorized',
    description: 'Authentication denied',
    event: 'When not passing any credentials & Token',
  },
  {
    status: 405,
    statusTypeName: 'Method Not Allowd',
    description: 'Method Not Allowd',
    event: 'Passing Incorrect Method',
  },
  {
    status: 415,
    statusTypeName: 'Unsupported Media Type',
    description: 'Unsupported Media TYpe',
    event: 'Unsupported Media TYpe',
  },
  {
    status: 404,
    statusTypeName: 'resource not found',
    description: 'resource not found',
    event: 'Passing Incorrect Resource',
  },
  {
    status: 502,
    statusTypeName: 'BadGateway',
    description: 'BadGateway',
    event: 'Mulesoft API Gateway Error',
  },
  {
    status: 500,
    statusTypeName: 'Internal Server Error',
    description: 'Internal Server Error',
    event: 'Backend API Error',
  },
  {
    status: 500,
    statusTypeName: 'Internal Server Error',
    description: 'HTTP:CONNECTIVITY - Server not reachable. Please try again.',
    event: 'Mulesoft connectivity issues',
  },
  {
    status: 500,
    statusTypeName: 'Internal Server Error',
    description: 'HTTP:TIMEOUT - Server not reachable. Please try again.',
    event: 'Mulesoft take to long in respond',
  },
  {
    status: 500,
    statusTypeName: 'Internal Server Error',
    description: 'HTTP:SERVICE_UNAVAILABLE - Server not reachable. Please try again.',
    event: 'Mulesoft take to long in respond',
  },
  {
    status: 500,
    statusTypeName: 'Internal Server Error',
    description: 'Quota has been exceeded',
    event: 'Request from DLMS to Mulesoft was too frecuents',
  },
];
